var exports = {
  "Z": "xcc377c0b--4648cc--section--anchor",
  "D": "xcc377c0b--4648cc--title",
};

module.exports = exports;
